import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Col, Container, Row } from 'react-bootstrap';

import styles from './Dog.module.scss';
import { useTranslate } from 'react-polyglot';
import { useAuth } from '../../../../Auth';
import { useAxios } from '../../../../AxiosHandler';
import { general } from '../../../../general';
import DogCardLooseRadar from './DogCards/DogCardLooseRadar/DogCardLooseRadar';
import DogCardLeashRadar from './DogCards/DogCardLeashRadar/DogCardLeashRadar';
import DogCardRabbitRadar from './DogCards/DogCardRabbitRadar/DogCardRabbitRadar';
import { Accordion } from 'react-bootstrap';
import DogCardFamilyTree from './DogCards/DogCardFamilyTree/DogCardFamilyTree';
import DogCardGlaukomLatest from './DogCards/DogCardGlaukomLatest/DogCardGlaukomLatest';
import DogCardHDIndexLatest from './DogCards/DogCardHDIndexLatest/DogCardHDIndexLatest';
import DogCardHDLatest from './DogCards/DogCardHDLatest/DogCardHDLatest';
import DogCardDwarfLatest from './DogCards/DogCardDwarfLatest/DogCardDwarfLatest';
import Card from '../../../Shared/Card/Card';
import DogCardLeashTests from './DogCards/DogCardLeashTests/DogCardLeashTests';
import DogCardLooseTests from './DogCards/DogCardLooseTests/DogCardLooseTests';
import DogCardPupsPrized from './DogCards/DogCardPupsPrized/DogCardPupsPrized';
import DogCardDogshow from './DogCards/DogCardDogshow/DogCardDogshow';
import DogCardNotes from './DogCards/DogCardNotes/DogCardNotes';
import DogOverview from './DogOverview/DogOverview';
import DogCardAtaksiLatest from "./DogCards/DogCardAtaksiLatest/DogCardAtaksiLatest";
import DogCardADLatest from './DogCards/DogCardADLatest/DogCardADLatest';
import PageTable from '../../../Shared/PageTable/PageTable';
import DogCardHareTests from './DogCards/DogCardHareTests/DogCardHareTests';
import DogHistory from './DogHistory/DogHistory';
import DogCardBirdTests from './DogCards/DogCardBirdTests/DogCardBirdTests';
import DogCardBirdFetchTests from './DogCards/DogCardBirdFetchTests/DogCardBirdFetchTests';

function Dog(props: DogProps) {
    const t = useTranslate();
    const navigate = useNavigate();
    const auth = useAuth();
    const axiosHandler = useAxios();
    const axios = axiosHandler.axios;
    const params = useParams();
    
    const [selectedDogId, setSelectedDogId] = useState<string | undefined>("");
    const [selectedDog, setSelectedDog] = useState<any | undefined>(undefined);

    const [hasDataDogCardGlaukomLatest, setHasDataDogCardGlaukomLatest] = useState<boolean>(false);
    const [hasDataDogCardAtaksiLatest, setHasDataDogCardAtaksiLatest] = useState<boolean>(false);
    const [hasDataDogCardHDIndexLatest, setHasDataDogCardHDIndexLatest] = useState<boolean>(false);
    const [hasDataDogCardDwarfLatest, setHasDataDogCardDwarfLatest] = useState<boolean>(false);
    const [hasDataDogCardHDLatest, setHasDataDogCardHDLatest] = useState<boolean>(false);
    const [hasDataDogCardADLatest, setHasDataDogCardADLatest] = useState<boolean>(false);
    const [hasDataDogCardLooseRadar, setHasDataDogCardLooseRadar] = useState<boolean>(false);
    const [hasDataDogCardLeashRadar, setHasDataDogCardLeashRadar] = useState<boolean>(false);
    const [hasDataDogCardRabbitRadar, setHasDataDogCardRabbitRadar] = useState<boolean>(false);
    const [hasDataDogCardLeashTests, setHasDataDogCardLeashTests] = useState<boolean>(false);
    const [hasDataDogCardLooseTests, setHasDataDogCardLooseTests] = useState<boolean>(false);
    const [hasDataDogCardHareTests, setHasDataDogCardHareTests] = useState<boolean>(false);
    const [hasDataDogCardBirdTests, setHasDataDogCardBirdTests] = useState<boolean>(false);
    const [hasDataDogCardBirdFetchTests, setHasDataDogCardBirdFetchTests] = useState<boolean>(false);
    const [hasDataDogCardExterior, setHasDataDogCardExterior] = useState<boolean>(false);
    const [hasDataDogCardPupsPrized, setHasDataDogCardPupsPrized] = useState<boolean>(false);
    const [hasDataDogCardPups, setHasDataDogCardPups] = useState<boolean>(false);

    const [hasHistory, setHasHistory] = useState<boolean>(false);

    const [hasDogNotes, setHasDogNotes] = useState<boolean>(false);

    const [previousDogIds, setPreviousDogIds] = useState<Array<string>>([]);

    const [pupsData, setPupsData] = useState<Array<any>>([]);
    const [pupsPrizeData, setPupsPrizeData] = useState<any>();

    const [sicknessReports, setSicknessReports] = useState<any>();

    const fieldsInTable = [
        "TIMESTAMP",
    ];

    function mapFieldToDataAnswer(field: string) {
        let fieldId = 0;
        switch (field) {
            case "dogName": fieldId = 1; break;
            case "ownerName": fieldId = 2; break;
        }
        return (data: any) => {
            return data.DATA.find((d: any) => d.TRAIT_ID == fieldId)?.answer;
        }
    }

    function getDog(dogId: string | undefined = selectedDogId) {
        if (dogId == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/dogs/" + dogId,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setSelectedDog(res.data);
            if (auth.selectedBreed != res.data?.BREED) auth.setSelectedBreed(res.data?.BREED);
        }).catch((err) => {
            console.log(err);
        });
    }

    function getPupsData(dogId: string | undefined = selectedDogId) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + dogId + "/pups",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            let groupedPups = general.groupBy(res.data, "DATE_BIRTH");
            setPupsData(groupedPups);
            if (res.data.length != 0) {
                setHasDataDogCardPups(true);
            } else {
                setHasDataDogCardPups(false);
            }
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getPupsPrizeData(dogId: string | undefined = selectedDogId) {
        if (auth.selectedBreed == undefined) return;
        axios.single({
            method: 'get',
            url: "/api/statistics/dog/" + dogId + "/pups/prizes",
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setPupsPrizeData(res.data);
        }).catch((err: any) => {
            console.log(err);
        });
    }

    function getSicknessReports(dogId: string | undefined = selectedDogId) {
        axios.single({
            method: 'get',
            url: "/api/dynschema/specialforanimal/" + dogId + "/sicknessreg/" + auth.selectedBreed,
            responseType: 'json',
            headers: { 'x-access-token': auth.user['token'], "selected-country": auth.selectedCountry || "all" }
        }).then((res) => {
            setSicknessReports(res.data);
        }).catch((err) => {
            console.log(err);
        });
    }

    function createTraitColumn(trait: any) {
        if (trait != undefined) {
            let column: any = {
                label: t("sicknessreports.fields." + trait),
                field: trait,
                noFilter: true,
            };

            if (trait == "TIMESTAMP") {
                column["override"] = (data: any) => {
                    return new Date(data.TIMESTAMP).toLocaleString("no-NO");
                }
            }

            switch (trait) {
                case "dogName":
                case "ownerName":
                    column["override"] = mapFieldToDataAnswer(trait);
                    break;
            }

            return column;
        } else {
            return undefined;
        }
    }

    function createColumns() {
        let columns: any[] = [];
        fieldsInTable.forEach((trait: string) => {
            columns.push(createTraitColumn(trait));
        });
        
        return columns;
    }

    useEffect(() => {
        if (params["dogid"] != undefined) {
            getDog(params["dogid"]);
        }
    }, [auth.selectedBreed]);

    useEffect(() => {
        setSelectedDogId(params["dogid"]);
        if (params["dogid"] != undefined && auth.selectedCountry != undefined) {
            getDog(params["dogid"]);
            getPupsData(params["dogid"]);
            getPupsPrizeData(params["dogid"]);
            getSicknessReports(params["dogid"]);
        }
    }, [auth.selectedCountry, params["dogid"]]);

    return (
        <div className="maincontent">
            <div className={styles.dog}>
                <h1>{t("dog.title")} {selectedDog?.NAME ?? "Laster inn .."} | {selectedDog?.REGNO}</h1>
                <hr/>
                <div className={styles.topbuttons}>
                    <button className="btn btn-primary" onClick={() => navigate("/hunder")}>{t("dog.buttons.back")}</button>
                    <button className="btn btn-primary" onClick={() => navigate("/hunder/paring/" + selectedDogId)}>{t("dog.buttons.breeding")}</button>
                </div>
                <hr/>
                { selectedDog != undefined ?
                    <>
                        <DogOverview
                            selectedDog={selectedDog}
                            selectedDogId={selectedDogId}
                        ></DogOverview>
                        &nbsp;
                        {/* Stamtavle first and open: the customer wants it in view when the page opens */}
                        <Accordion className={styles.accordion} defaultActiveKey="2">
                            <Accordion.Item className={styles.accordionitem} eventKey="2">
                                <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.relationship.title")}</Accordion.Header>
                                <Accordion.Body>
                                    <p>{t("dog.statistics.areas.relationship.helptext")}</p>
                                    {/* Button to previous dogid */}
                                    <button
                                        className="btn btn-primary"
                                        style={{
                                            display: previousDogIds.length > 0 ? "block" : "none"
                                        }}
                                        onClick={() => {
                                            let previousDogId = previousDogIds.pop();
                                            if (previousDogId != undefined) {
                                                navigate("/hunder/" + previousDogId);
                                                setSelectedDogId(previousDogId);
                                                getDog(previousDogId);
                                            }
                                        }}
                                    >{t("dog.statistics.areas.relationship.previous")}</button>
                                    <br/>
                                    <DogCardFamilyTree
                                        dogId={selectedDogId}
                                        onClick={(dogId: string) => {
                                            navigate("/hunder/" + dogId);
                                            let previousDogIdsCopy = previousDogIds;
                                            previousDogIdsCopy.push(selectedDogId ?? "");
                                            setPreviousDogIds(previousDogIdsCopy);
                                            setSelectedDogId(dogId);
                                            getDog(dogId);
                                        }}
                                    />
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item
                                className={styles.accordionitem}
                                eventKey="0"
                                style={{
                                    display:
                                        sicknessReports != undefined && sicknessReports.length > 0
                                        ? "block" : "none"
                                }}
                            >
                                <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.sicknessreports.title")}</Accordion.Header>
                                <Accordion.Body>
                                    <Container className={styles.container}>
                                        { auth.selectedBreed != undefined &&
                                            <PageTable
                                                dataUrl={"/api/schema/getAllPaged/" + auth.selectedBreed}
                                                onLineClick={(dataLine: any) => {
                                                    navigate("/sykdomsrapporter/" + dataLine.SCHEMA_KEY + "/" + dataLine.ID);
                                                }}
                                                options={{
                                                    showFields: [
                                                        ...createColumns(),
                                                    ],
                                                }}
                                                permaFilters={[
                                                    {
                                                        field: "ANIMAL_ID",
                                                        exact: false,
                                                        type: "and",
                                                        values: [selectedDogId]
                                                    },
                                                    {
                                                        field: "STATUS",
                                                        exact: false,
                                                        type: "and",
                                                        values: ["accepted"]
                                                    },
                                                    {
                                                        field: "SCHEMA_KEY",
                                                        exact: false,
                                                        type: "and",
                                                        values: ["sicknessreg"]
                                                    }
                                                ]}
                                                selectedTraits={fieldsInTable}
                                                clickable
                                                defaultSortDirection="DESC"
                                                defaultSortField="TIMESTAMP"
                                                hidePagination={false}
                                                hidePagesize={false}
                                                hideFilter={false}
                                            />
                                        }
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item
                                className={styles.accordionitem}
                                eventKey="1"
                                style={{
                                    display:
                                        hasDataDogCardGlaukomLatest ||
                                        hasDataDogCardHDIndexLatest ||
                                        hasDataDogCardHDLatest ||
                                        hasDataDogCardADLatest ||
                                        hasDataDogCardAtaksiLatest ||
                                        hasDataDogCardDwarfLatest
                                        ? "block" : "none"
                                }}
                            >
                                <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.health.title")}</Accordion.Header>
                                <Accordion.Body>
                                    <Container className={styles.container}>
                                        <Row className={styles.row}>
                                            <Col
                                                sm="12"
                                                md="6"
                                                className={styles.col}
                                                style={{
                                                    display:
                                                        hasDataDogCardGlaukomLatest
                                                        ? "block" : "none"
                                                }}
                                            >
                                                <DogCardGlaukomLatest
                                                    dogId={selectedDogId}
                                                    onDataLoaded={(data) => {
                                                        if ((data?.length ?? 0) != 0) {
                                                            setHasDataDogCardGlaukomLatest(true);
                                                        } else {
                                                            setHasDataDogCardGlaukomLatest(false);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                sm="12"
                                                md="6"
                                                className={styles.col}
                                                style={{
                                                    display:
                                                        hasDataDogCardGlaukomLatest
                                                            ? "block" : "none"
                                                }}
                                            >
                                                <DogCardAtaksiLatest
                                                    dogId={selectedDogId}
                                                    onDataLoaded={(data) => {
                                                        if ((data?.length ?? 0) != 0) {
                                                            setHasDataDogCardAtaksiLatest(true);
                                                        } else {
                                                            setHasDataDogCardAtaksiLatest(false);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                sm="12"
                                                md="6"
                                                className={styles.col}
                                                style={{
                                                    display:
                                                        hasDataDogCardHDLatest
                                                        ? "block" : "none"
                                                }}
                                            >
                                                <DogCardHDLatest
                                                    dogId={selectedDogId}
                                                    onDataLoaded={(data) => {
                                                        if ((data?.length ?? 0) != 0) {
                                                            setHasDataDogCardHDLatest(true);
                                                        } else {
                                                            setHasDataDogCardHDLatest(false);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                sm="12"
                                                md="6"
                                                className={styles.col}
                                                style={{
                                                    display:
                                                        hasDataDogCardADLatest
                                                        ? "block" : "none"
                                                }}
                                            >
                                                <DogCardADLatest
                                                    dogId={selectedDogId}
                                                    onDataLoaded={(data) => {
                                                        setHasDataDogCardADLatest(data != null);
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                sm="12"
                                                md="6"
                                                className={styles.col}
                                                style={{
                                                    display:
                                                        hasDataDogCardHDIndexLatest
                                                        ? "block" : "none"
                                                }}
                                            >
                                                <DogCardHDIndexLatest
                                                    dogId={selectedDogId}
                                                    onDataLoaded={(data) => {
                                                        if ((data?.length ?? 0) != 0) {
                                                            setHasDataDogCardHDIndexLatest(true);
                                                        } else {
                                                            setHasDataDogCardHDIndexLatest(false);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                            <Col
                                                sm="12"
                                                md="6"
                                                className={styles.col}
                                                style={{
                                                    display:
                                                        hasDataDogCardDwarfLatest
                                                        ? "block" : "none"
                                                }}
                                            >
                                                <DogCardDwarfLatest
                                                    dogId={selectedDogId}
                                                    onDataLoaded={(data) => {
                                                        if ((data?.length ?? 0) != 0) {
                                                            setHasDataDogCardDwarfLatest(true);
                                                        } else {
                                                            setHasDataDogCardDwarfLatest(false);
                                                        }
                                                    }}
                                                />
                                            </Col>
                                        </Row>
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item
                                className={styles.accordionitem}
                                eventKey="3"
                                style={{
                                    display:
                                        hasDataDogCardPups ||
                                        hasDataDogCardPupsPrized
                                        ? "block" : "none"
                                }}
                            >
                                <Accordion.Header
                                    className={styles.accordionheader}
                                >{t("dog.statistics.areas.children.title")}</Accordion.Header>
                                <Accordion.Body>
                                    <p>{t("dog.statistics.areas.children.helptext")}</p>
                                    <Container className={styles.container}>
                                        <Row className={styles.row}>
                                            <Col
                                                sm="12"
                                                md="6"
                                                className={styles.col}
                                                style={{
                                                    display: hasDataDogCardPups ? "block" : "none"
                                                }}
                                            >
                                                <Card
                                                    children={<div>
                                                        {pupsData.map((pups, index) => 
                                                            <div
                                                                key={index}
                                                                className={styles.litter}
                                                            >
                                                                <h5>{t("dog.statistics.areas.children.litterdateprefix")} {general.dateToString(new Date(pups[0].DATE_BIRTH))}</h5>
                                                                {pups.sort(((a: any, b: any) => a.SEX < b.SEX ? 1 : -1)).map((pup: any, index: any) => 
                                                                    <div
                                                                        key={index}
                                                                        className={styles.puplink}
                                                                        style={{
                                                                            cursor: "pointer"
                                                                        }}
                                                                        onClick={() => {
                                                                            // Navigate to dog by refreshing the page
                                                                            window.location.href = "/hunder/" + pup.ANIMAL_ID;
                                                                            // navigate("/hunder/" + pup.ANIMAL_ID);
                                                                            let previousDogIdsCopy = previousDogIds;
                                                                            previousDogIdsCopy.push(selectedDogId ?? "");
                                                                            setPreviousDogIds(previousDogIdsCopy);
                                                                            setSelectedDogId(pup.ANIMAL_ID);
                                                                            getDog(pup.ANIMAL_ID);
                                                                        }}
                                                                    >
                                                                        <p>{pup.NAME} ({pup.REGNO}) - {t("general." + pup.SEX)}</p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>}
                                                ></Card>
                                            </Col>
                                            <Col
                                                sm="12"
                                                md="6"
                                                lg="3"
                                                className={styles.col}
                                                style={{
                                                    display: hasDataDogCardPupsPrized ? "block" : "none"
                                                }}
                                            >
                                                <DogCardPupsPrized
                                                    dogId={selectedDogId}
                                                    onDataLoaded={(data) => {
                                                        if (data.length != 0) {
                                                            setHasDataDogCardPupsPrized(true);
                                                        } else {
                                                            setHasDataDogCardPupsPrized(false);
                                                        }
                                                    }}
                                                ></DogCardPupsPrized>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item
                                className={styles.accordionitem}
                                eventKey="4"
                                style={{
                                    display:
                                        hasDataDogCardLooseRadar ||
                                        hasDataDogCardLeashRadar ||
                                        hasDataDogCardRabbitRadar ||
                                        hasDataDogCardLeashTests ||
                                        hasDataDogCardLooseTests ||
                                        //hasDataDogCardBirdTests ||
                                        //hasDataDogCardBirdFetchTests ||
                                        hasDataDogCardHareTests
                                        ? "block" : "none"
                                }}
                            >
                                <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.use.title")}</Accordion.Header>
                                <Accordion.Body>
                                    <Accordion className={styles.accordion}>
                                        <Accordion.Item
                                            className={styles.accordionitem}
                                            eventKey="100"
                                            style={{
                                                display:
                                                    hasDataDogCardLeashRadar ||
                                                    hasDataDogCardLeashTests
                                                    ? "block" : "none"
                                            }}
                                        >
                                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.use.leash.title")}</Accordion.Header>
                                            <Accordion.Body>
                                                <Container className={styles.container}>
                                                    <Row className={styles.row}>
                                                        <Col
                                                            sm="12"
                                                            md="6"
                                                            className={styles.col}
                                                            style={{
                                                                display:
                                                                    hasDataDogCardLeashRadar
                                                                    ? "block" : "none"
                                                            }}
                                                        >
                                                            <DogCardLeashRadar
                                                                dogId={selectedDogId}
                                                                onDataLoaded={(data) => {
                                                                    if (data.length != 0) {
                                                                        setHasDataDogCardLeashRadar(true);
                                                                    } else {
                                                                        setHasDataDogCardLeashRadar(false);
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col
                                                            sm="12"
                                                            md="6"
                                                            className={styles.col}
                                                            style={{
                                                                display:
                                                                    hasDataDogCardLeashTests
                                                                    ? "block" : "none"
                                                            }}
                                                        >
                                                            <DogCardLeashTests
                                                                dogId={selectedDogId}
                                                                onDataLoaded={(data) => {
                                                                    if (data.length != 0) {
                                                                        setHasDataDogCardLeashTests(true);
                                                                    } else {
                                                                        setHasDataDogCardLeashTests(false);
                                                                    }
                                                                }}
                                                            ></DogCardLeashTests>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item
                                            className={styles.accordionitem}
                                            eventKey="101"
                                            style={{
                                                display:
                                                    hasDataDogCardLooseRadar ||
                                                    hasDataDogCardLooseTests
                                                    ? "block" : "none"
                                            }}
                                        >
                                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.use.loose.title")}</Accordion.Header>
                                            <Accordion.Body>
                                                <Container className={styles.container}>
                                                    <Row className={styles.row}>
                                                        <Col
                                                            sm="12"
                                                            md="6"
                                                            className={styles.col}
                                                            style={{
                                                                display:
                                                                    hasDataDogCardLooseRadar
                                                                    ? "block" : "none"
                                                            }}
                                                        >
                                                            <DogCardLooseRadar
                                                                dogId={selectedDogId}
                                                                onDataLoaded={(data) => {
                                                                    if (data.length != 0) {
                                                                        setHasDataDogCardLooseRadar(true);
                                                                    } else {
                                                                        setHasDataDogCardLooseRadar(false);
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col
                                                            sm="12"
                                                            md="6"
                                                            className={styles.col}
                                                            style={{
                                                                display:
                                                                    hasDataDogCardLooseTests
                                                                    ? "block" : "none"
                                                            }}
                                                        >
                                                            <DogCardLooseTests
                                                                dogId={selectedDogId}
                                                                onDataLoaded={(data) => {
                                                                    if (data.length != 0) {
                                                                        setHasDataDogCardLooseTests(true);
                                                                    } else {
                                                                        setHasDataDogCardLooseTests(false);
                                                                    }
                                                                }}
                                                            ></DogCardLooseTests>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item
                                            className={styles.accordionitem}
                                            eventKey="102"
                                            style={{
                                                display:
                                                    hasDataDogCardRabbitRadar ||
                                                    hasDataDogCardHareTests
                                                    ? "block" : "none"
                                            }}
                                        >
                                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.use.hare.title")}</Accordion.Header>
                                            <Accordion.Body>
                                                <Container className={styles.container}>
                                                    <Row className={styles.row}>
                                                        <Col
                                                            sm="12"
                                                            md="6"
                                                            className={styles.col}
                                                            style={{
                                                                display:
                                                                    hasDataDogCardRabbitRadar
                                                                    ? "block" : "none"
                                                            }}
                                                        >
                                                            <DogCardRabbitRadar
                                                                dogId={selectedDogId}
                                                                onDataLoaded={(data) => {
                                                                    if (data.length != 0) {
                                                                        setHasDataDogCardRabbitRadar(true);
                                                                    } else {
                                                                        setHasDataDogCardRabbitRadar(false);
                                                                    }
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col
                                                            sm="12"
                                                            md="6"
                                                            className={styles.col}
                                                            style={{
                                                                display:
                                                                    hasDataDogCardHareTests
                                                                    ? "block" : "none"
                                                            }}
                                                        >
                                                            <DogCardHareTests
                                                                dogId={selectedDogId}
                                                                onDataLoaded={(data) => {
                                                                    if (data.length != 0) {
                                                                        setHasDataDogCardHareTests(true);
                                                                    } else {
                                                                        setHasDataDogCardHareTests(false);
                                                                    }
                                                                }}
                                                            ></DogCardHareTests>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        {/* <Accordion.Item
                                            className={styles.accordionitem}
                                            eventKey="103"
                                            style={{
                                                display:
                                                    hasDataDogCardBirdTests
                                                    ? "block" : "none"
                                            }}
                                        >
                                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.use.bird.title")}</Accordion.Header>
                                            <Accordion.Body>
                                                <Container className={styles.container}>
                                                    <Row className={styles.row}>
                                                        <Col
                                                            sm="12"
                                                            md="6"
                                                            className={styles.col}
                                                            style={{
                                                                display:
                                                                    hasDataDogCardBirdTests
                                                                    ? "block" : "none"
                                                            }}
                                                        >
                                                            <DogCardBirdTests
                                                                dogId={selectedDogId}
                                                                onDataLoaded={(data) => {
                                                                    if (data.length != 0) {
                                                                        setHasDataDogCardBirdTests(true);
                                                                    } else {
                                                                        setHasDataDogCardBirdTests(false);
                                                                    }
                                                                }}
                                                            ></DogCardBirdTests>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Body>
                                        </Accordion.Item> */}
                                        {/* <Accordion.Item
                                            className={styles.accordionitem}
                                            eventKey="104"
                                            style={{
                                                display:
                                                    hasDataDogCardBirdFetchTests
                                                    ? "block" : "none"
                                            }}
                                        >
                                            <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.use.birdfetch.title")}</Accordion.Header>
                                            <Accordion.Body>
                                                <Container className={styles.container}>
                                                    <Row className={styles.row}>
                                                        <Col
                                                            sm="12"
                                                            md="6"
                                                            className={styles.col}
                                                            style={{
                                                                display:
                                                                    hasDataDogCardBirdFetchTests
                                                                    ? "block" : "none"
                                                            }}
                                                        >
                                                            <DogCardBirdFetchTests
                                                                dogId={selectedDogId}
                                                                onDataLoaded={(data) => {
                                                                    if (data.length != 0) {
                                                                        setHasDataDogCardBirdFetchTests(true);
                                                                    } else {
                                                                        setHasDataDogCardBirdFetchTests(false);
                                                                    }
                                                                }}
                                                            ></DogCardBirdFetchTests>
                                                        </Col>
                                                    </Row>
                                                </Container>
                                            </Accordion.Body>
                                        </Accordion.Item> */}
                                    </Accordion>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item
                                className={styles.accordionitem}
                                eventKey="5"
                                style={{
                                    display:
                                        hasDataDogCardExterior
                                        ? "block" : "none"
                                }}
                            >
                                <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.exterior.title")}</Accordion.Header>
                                <Accordion.Body>
                                    <Container className={styles.container}>
                                        <Row className={styles.row}>
                                            <Col sm="12" className={styles.col}>
                                                <DogCardDogshow
                                                    title={t("dog.statistics.areas.exterior.dogshows.title")}
                                                    dogId={selectedDogId}
                                                    onDataLoaded={(data) => {
                                                        if (data.length != 0) {
                                                            setHasDataDogCardExterior(true);
                                                        } else {
                                                            setHasDataDogCardExterior(false);
                                                        }
                                                    }}
                                                ></DogCardDogshow>
                                            </Col>
                                        </Row>
                                    </Container>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <hr/>
                        <Accordion
                            className={styles.accordion}
                            style={{
                                display: hasHistory ? "block" : "none"
                            }}
                        >
                            <Accordion.Item
                                className={styles.accordionitem}
                                eventKey="0"
                            >
                                <Accordion.Header className={styles.accordionheader}>{t("dog.statistics.areas.history.title")}</Accordion.Header>
                                <Accordion.Body>
                                    <DogHistory
                                        dogId={selectedDogId}
                                        onDataLoaded={(hasData: boolean) => {
                                            setHasHistory(hasData);
                                        }}
                                    ></DogHistory>
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                        <Container
                            className={styles.container}
                            style={{
                                display: 
                                    general.getBreedAccess(auth.user, auth.selectedBreed) == "admin" ||
                                    hasDogNotes
                                ? "block" : "none"
                            }}
                        >
                            <Row className={styles.row}>
                                <Col
                                    sm="12"
                                    className={styles.col}
                                >
                                    <DogCardNotes
                                        dogId={selectedDogId}
                                        onDataLoaded={(data) => {
                                            if (data.length != 0) {
                                                setHasDogNotes(true);
                                            } else {
                                                setHasDogNotes(false);
                                            }
                                        }}
                                    ></DogCardNotes>
                                </Col>
                            </Row>
                        </Container>
                    </>
                : null }
            </div>
        </div>
    );
}

class DogProps {
    
}

export default Dog;
